import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeFastFirm } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CompanyService } from "../../../services/CompanyService";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAuthorizedPerson } from "../../../models/response/company/GetCompanyByIdResponse";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import PageHeader from "../../../components/PageHeader";
import { FastFirmFields } from "../../../components/FastFirm";
import moment from "moment";
import { AntrepoOfferService } from "../../../services/AntrepoOfferService";
import { AddAntrepoOfferResponse } from "../../../models/response/antrepoOffer/AddAntrepoOfferResponse";
import { GetAntrepoOfferByIdResponse, GetAntrepoOfferByIdResponseAntrepoOfferDetail, GetAntrepoOfferByIdResponseFileArchive } from "../../../models/response/antrepoOffer/GetAntrepoOfferByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import { ServiceService } from "../../../services/ServiceService";
import { GetServiceByIdResponse, GetServiceByIdResponseServiceMultiplier } from "../../../models/response/service/GetServiceByIdResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import OfferDetails from "./Components/OfferDetails";
import FileArchives from "./Components/FileArchives";
import ActionButtons from "./Components/ActionButtons";
import { ChangeAntrepoOfferStatusResponse } from "../../../models/response/antrepoOffer/ChangeAntrepoOfferStatusResponse";
import { CopyAntrepoOfferResponse } from "../../../models/response/antrepoOffer/CopyAntrepoOfferResponse";
import { GetMeetingByIdResponse } from "../../../models/response/meeting/GetMeetingByIdResponse";
import { MeetingService } from "../../../services/MeetingService";
import { MeetingCompanyTypeEnum, OfferStatusEnum } from "../../../models/common/Enums";
import { ChangeCompanyInitialCompanyTypeResponse } from "../../../models/request/company/ChangeCompanyInitialCompanyTypeResponse";
import { AgreementService } from "../../../services/AgreementService";
import { AddAgreementRequest, AddAgreementRequestAgreementDetail } from "../../../models/request/agreement/AddAgreementRequest";
import { AddAgreementResponse } from "../../../models/response/agreement/AddAgreementResponse";
import { GetAgreementByIdResponse } from "../../../models/response/agreement/GetAgreementByIdResponse";
import { PriceService } from "../../../services/PriceService";
import { GetPriceByIdResponse } from "../../../models/response/price/GetPriceByIdResponse";

const AntrepoOfferAdd = () => {
    const navigate = useNavigate();
    const pageName = "Pazarlama > Teklifler > Antrepo Teklifleri"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const offerDetailsRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [antrepoOfferId, setAntrepoOfferId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [companyAuthorizedPersons, setCompanyAuthorizedPersons] = useState<GetCompanyByIdResponseCompanyAuthorizedPerson[]>([]);
    const [selectedAuthorizedPerson, setSelectedAuthorizedPerson] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [phoneList, setPhoneList] = useState<CustomSingleSelectModel[]>([]);
    const [selectedPhone, setSelectedPhone] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [emailList, setEmailList] = useState<CustomSingleSelectModel[]>([]);
    const [selectedEmail, setSelectedEmail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [startDate, setStartDate] = useState<string | undefined>(undefined);
    const [endDate, setEndDate] = useState<string | undefined>(undefined);
    const [selectedOfferStatus, setSelectedOfferStatus] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [antrepoOfferDetails, setAntrepoOfferDetails] = useState<GetAntrepoOfferByIdResponseAntrepoOfferDetail[]>([]);
    const [fileArchives, setFileArchives] = useState<GetAntrepoOfferByIdResponseFileArchive[]>([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isPartialDisabled, setIsPartialDisabled] = useState(false);
    const [meetingId, setMeetingId] = useState<string | undefined>(undefined);

    const [canCreateAgreement, setCanCreateAgreement] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        var meetingId = searchParams.get("meetingId");
        getData(id, meetingId);
    }, [])

    const saveAgreement = async () => {
        try {
            if (antrepoOfferDetails.filter(x => x.isSelected).find(x => Helpers.isEmpty(x.agreementId))) {
                toast.error('Anlaşma oluşturulabilmesi için seçilen teklif detaylarının Anlaşma Adı alanı dolu olmalıdır!')
                return;
            }

            dispatch(storeActivityIndicator(true));

            var agreementIds = [...new Set(antrepoOfferDetails.filter(x => x.isSelected).map(x => x.agreementId))];

            for (var i = 0; i < agreementIds.length; i++) {
                var agreementDetails = antrepoOfferDetails.filter(x => x.agreementId == agreementIds[i]);

                var response2: GetAgreementByIdResponse = await AgreementService.getAgreementById(agreementIds[i] + '');

                if (!response2.isSuccess) {
                    toast.error(response2.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                var response3: GetPriceByIdResponse = await PriceService.getPriceById(agreementDetails[0].priceId + '');

                if (!response3.isSuccess) {
                    toast.error(response3.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                var o: AddAgreementRequest = {
                    agreementId: agreementIds[i],
                    endDate: endDate,
                    heatControlDetailId: agreementDetails[0].heatControlDetailId,
                    isClosedArea: agreementDetails[0].isClosedArea,
                    isCustomActive: true,
                    isHeatControllerRoom: agreementDetails[0].isHeatControllerRoom,
                    isIncome: true,
                    isOpenArea: agreementDetails[0].isOpenArea,
                    isOutcome: false,
                    name: agreementDetails[0].agreementName,
                    productKindId: response3?.data?.productKindId,
                    refNo: response2?.data?.refNo,
                    selectedCompanyId: selectedCurrentCompany?.value,
                    startDate: startDate,
                    agreementDetails: agreementDetails.map(function (x) {

                        var o: AddAgreementRequestAgreementDetail = {
                            agreementDetailId: undefined,
                            currencyTypeId: x.currencyTypeId,
                            multiplier1Id: x.multiplier1Id,
                            multiplier2Id: x.multiplier2Id,
                            serviceId: x.serviceId,
                            unitPrice: x.unitPrice?.toString(),
                            minPrice: x.minPrice?.toString(),
                            potTypeId: x.potTypeId,
                        }

                        return o;
                    }),
                }

                var response: AddAgreementResponse = await AgreementService.addAgreement(o);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }
            }

            saveAntrepoOffer();
        } catch (error: any) {
            toast.error(error)
        }
    }

    const getData = async (_id: string | undefined | null = undefined, _meetingId: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (_meetingId) {
                setMeetingId(_meetingId);
                var response3: GetMeetingByIdResponse = await MeetingService.getMeetingById(_meetingId);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                if (response3.data.selectedCompanyId && response3.data.selectedCompanyName) {
                    setSelectedCurrentCompany({ label: response3.data.selectedCompanyName, value: response3.data.selectedCompanyId });

                    var response2: GetCompanyByIdResponse = await CompanyService.getCompanyById(response3.data.selectedCompanyId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    setCompanyAuthorizedPersons(response2.data.companyAuthorizedPersons);

                    var authPerson = response2.data.companyAuthorizedPersons.find(x => x.companyAuthorizedPersonId == response3.data.selectedPersonAuthorizedPersonId);

                    if (authPerson) {
                        authorizedPersonSelectHandler({ label: authPerson.name + ' ' + authPerson.surname, value: authPerson.companyAuthorizedPersonId }, response2.data.companyAuthorizedPersons, response3.data.selectedPersonAuthorizedPersonPhone, response3.data.selectedPersonAuthorizedPersonEmail);
                    }
                }

                setIsPartialDisabled(true);
            }

            if (id) {
                var response: GetAntrepoOfferByIdResponse = await AntrepoOfferService.getAntrepoOfferById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setRefNo(response.data.refNo);
                setMeetingId(response.data.meetingId);

                if (response.data.offerStatusAdditionalValue1 == OfferStatusEnum.ONAYLANDI && response.data.antrepoOfferDetails.length > 0 && response.data.antrepoOfferDetails.filter(x => Helpers.isEmpty(x.agreementId)).length > 0) {
                    setCanCreateAgreement(true);
                }

                if (response.data.selectedCompanyId && response.data.selectedCompanyName) {
                    setSelectedCurrentCompany({ label: response.data.selectedCompanyName, value: response.data.selectedCompanyId });

                    var response2: GetCompanyByIdResponse = await CompanyService.getCompanyById(response.data.selectedCompanyId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    setCompanyAuthorizedPersons(response2.data.companyAuthorizedPersons);

                    var authPerson = response2.data.companyAuthorizedPersons.find(x => x.companyAuthorizedPersonId == response.data.selectedPersonAuthorizedPersonId);

                    if (authPerson) {
                        authorizedPersonSelectHandler({ label: authPerson.name + ' ' + authPerson.surname, value: authPerson.companyAuthorizedPersonId }, response2.data.companyAuthorizedPersons, response.data.selectedPersonAuthorizedPersonPhone, response.data.selectedPersonAuthorizedPersonEmail);
                    }
                }

                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);

                if (response.data.offerStatusId && response.data.offerStatusName) {
                    setSelectedOfferStatus({ label: response.data.offerStatusName, value: response.data.offerStatusId, additionalValue1: response.data.offerStatusAdditionalValue1 });
                }

                setAntrepoOfferDetails(response.data.antrepoOfferDetails);
                setFileArchives(response.data.fileArchives);

                if (!Helpers.isEmpty(response.data.offerStatusChangeDate)) {
                    setIsDisabled(true);
                }

                setAntrepoOfferId(response.data.antrepoOfferId);
            }
            else {
                setStartDate(moment().add('hours', 3).toISOString().split('T')[0])
                setEndDate(moment().add('hours', 3).add('days', 15).toISOString().split('T')[0])

                var response5: GetConstantListResponse = await ConstantService.getConstantList('OFFER_STATUS', undefined, "1");

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    setSelectedOfferStatus({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveAntrepoOffer = async () => {
        try {
            if (!selectedCurrentCompany)
                toast.error('Müşteri alanını doldurunuz!')
            else if (!selectedAuthorizedPerson)
                toast.error('Yetkili Kişi alanını doldurunuz!')
            else if (!selectedPhone)
                toast.error('Yetkili Telefon alanını doldurunuz!')
            else if (!selectedEmail)
                toast.error('Yetkili E-Posta alanını doldurunuz!')
            else if (!selectedOfferStatus)
                toast.error('Teklif Durumu alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddAntrepoOfferResponse = await AntrepoOfferService.addAntrepoOffer({
                    antrepoOfferId: antrepoOfferId,
                    refNo: refNo,
                    selectedCompanyId: selectedCurrentCompany.value,
                    selectedPersonAuthorizedPersonEmail: selectedEmail.value,
                    selectedPersonAuthorizedPersonId: selectedAuthorizedPerson.value,
                    selectedPersonAuthorizedPersonPhone: selectedPhone.value,
                    endDate: endDate,
                    startDate: startDate,
                    offerStatusId: selectedOfferStatus.value,
                    antrepoOfferDetails: antrepoOfferDetails.map(function (x) {
                        return {
                            antrepoOfferDetailId: x.antrepoOfferDetailId,
                            currencyTypeId: x.currencyTypeId,
                            currencyTypeName: x.currencyTypeName,
                            description: x.description,
                            taxRate: x.taxRate,
                            multiplier1Id: x.multiplier1Id,
                            multiplier2Id: x.multiplier2Id,
                            serviceId: x.serviceId,
                            unitPrice: x.unitPrice,
                            isOpenArea: x.isOpenArea ? 1 : 0,
                            isClosedArea: x.isClosedArea ? 1 : 0,
                            heatControlDetailId: x.heatControlDetailId,
                            isHeatControllerRoom: x.isHeatControllerRoom ? 1 : 0,
                            minPrice: x.minPrice,
                            potTypeId: x.potTypeId,
                            priceId: x.priceId,
                            agreementId: x.agreementId,
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                    meetingId: meetingId
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                // navigate(Helpers.getGoBackUrl())
                navigate('/antrepooffer/list');
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const authorizedPersonSelectHandler = (_selectedAuthorizedPerson: CustomSingleSelectModel | undefined, _list: GetCompanyByIdResponseCompanyAuthorizedPerson[] | undefined = undefined, phoneToBeSet: string | undefined = undefined, emailToBeSet: string | undefined = undefined) => {
        setSelectedAuthorizedPerson(_selectedAuthorizedPerson);

        if (_selectedAuthorizedPerson) {
            var person = (_list ? _list : companyAuthorizedPersons).find(x => x.companyAuthorizedPersonId == _selectedAuthorizedPerson.value);

            if (person) {
                var phoneList = [];

                if (!Helpers.isEmpty(person.phone1))
                    phoneList.push(person.phone1);

                if (!Helpers.isEmpty(person.phone2))
                    phoneList.push(person.phone2);

                setPhoneList(phoneList.map(function (x) {
                    return { label: x + '', value: x + '' }
                }));

                if (phoneToBeSet) {
                    setSelectedPhone({ label: phoneToBeSet, value: phoneToBeSet });
                }
                else {
                    if (phoneList.length == 1)
                        setSelectedPhone({ label: phoneList[0] + '', value: phoneList[0] + '' });
                    else
                        setSelectedPhone(undefined);
                }

                var emailList = [];

                if (!Helpers.isEmpty(person.email))
                    emailList.push(person.email);

                setEmailList(emailList.map(function (x) {
                    return { label: x + '', value: x + '' }
                }));

                if (emailToBeSet) {
                    setSelectedEmail({ label: emailToBeSet, value: emailToBeSet });
                }
                else {
                    if (emailList.length == 1)
                        setSelectedEmail({ label: emailList[0] + '', value: emailList[0] + '' });
                    else
                        setSelectedEmail(undefined);
                }

                return;
            }
        }

        setSelectedPhone(undefined);
        setSelectedEmail(undefined);
    }

    const changeOfferStatus = async (_newStatus: string) => {
        try {
            dispatch(storeActivityIndicator(true));
            var response5: GetConstantListResponse = await ConstantService.getConstantList('OFFER_STATUS', undefined, _newStatus);

            if (!response5.isSuccess) {
                toast.error(response5.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            if (response5.data.length > 0) {
                var response: ChangeAntrepoOfferStatusResponse = await AntrepoOfferService.changeAntrepoOfferStatus(antrepoOfferId, response5.data[0].constantId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    dispatch(storeActivityIndicator(false))
                    return;
                }

                if (_newStatus == OfferStatusEnum.ONAYLANDI && selectedCurrentCompany) {
                    var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, MeetingCompanyTypeEnum.CALISILAN_MUSTERI);

                    if (!response5.isSuccess) {
                        toast.error(response5.message)
                        dispatch(storeActivityIndicator(false))
                        return;
                    }

                    var response2: ChangeCompanyInitialCompanyTypeResponse = await CompanyService.changeCompanyInitialCompanyType(selectedCurrentCompany.value, response5.data[0].constantId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        dispatch(storeActivityIndicator(false))
                        return;
                    }
                }

                if (_newStatus == OfferStatusEnum.REVIZE_EDILDI) {
                    var response: CopyAntrepoOfferResponse = await AntrepoOfferService.copyAntrepoOffer(antrepoOfferId);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        dispatch(storeActivityIndicator(false))
                        return;
                    }

                    toast.success(response.message);
                    getData(response.data.antrepoOfferId);
                }
                else {
                    toast.success(response.message);
                    getData();
                }
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={Helpers.isEmpty(antrepoOfferId) ? undefined :
                <ActionButtons
                    changeOfferStatus={changeOfferStatus}
                    isDisabled={isDisabled}
                    selectedOfferStatus={selectedOfferStatus}
                    saveAgreement={saveAgreement}
                    canCreateAgreement={canCreateAgreement}
                    antrepoOfferDetails={antrepoOfferDetails}
                />
            } />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Teklif Detayları', ref: offerDetailsRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        authorizedPersonSelectHandler={authorizedPersonSelectHandler}
                        companyAuthorizedPersons={companyAuthorizedPersons}
                        emailList={emailList}
                        endDate={endDate}
                        generalInformationRef={generalInformationRef}
                        phoneList={phoneList}
                        selectedAuthorizedPerson={selectedAuthorizedPerson}
                        selectedCurrentCompany={selectedCurrentCompany}
                        selectedEmail={selectedEmail}
                        selectedPhone={selectedPhone}
                        setCompanyAuthorizedPersons={setCompanyAuthorizedPersons}
                        setEmailList={setEmailList}
                        setEndDate={setEndDate}
                        setPhoneList={setPhoneList}
                        setSelectedAuthorizedPerson={setSelectedAuthorizedPerson}
                        setSelectedCurrentCompany={setSelectedCurrentCompany}
                        setSelectedEmail={setSelectedEmail}
                        setSelectedPhone={setSelectedPhone}
                        setStartDate={setStartDate}
                        startDate={startDate}
                        isDisabled={isDisabled}
                        isPartialDisabled={isPartialDisabled}
                        refNo={refNo}
                        selectedOfferStatus={selectedOfferStatus}
                        setRefNo={setRefNo}
                        setSelectedOfferStatus={setSelectedOfferStatus}
                    />

                    <OfferDetails
                        antrepoOfferDetails={antrepoOfferDetails}
                        offerDetailsRef={offerDetailsRef}
                        setAntrepoOfferDetails={setAntrepoOfferDetails}
                        isDisabled={isDisabled}
                        selectedOfferStatus={selectedOfferStatus}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                        isDisabled={isDisabled}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button disabled={isDisabled} className="btn btn-primary btn-sm" onClick={saveAntrepoOffer}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>


        </React.Fragment>
    )
}

export default AntrepoOfferAdd;